<template>
  <div class="c-loading">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'loading',
};
</script>

<style lang="scss">
.c-loading {
  display: block;
  position: relative;
  margin: 0 auto;
  width: 64px;
  height: 64px;
}

.c-loading div {
  position: absolute;
  top: 27px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: $colour-nhs-blue;
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}

.c-loading div:nth-child(1) {
  left: 6px;
  animation: c-loading1 0.6s infinite;
}

.c-loading div:nth-child(2) {
  left: 6px;
  animation: c-loading2 0.6s infinite;
}

.c-loading div:nth-child(3) {
  left: 26px;
  animation: c-loading2 0.6s infinite;
}

.c-loading div:nth-child(4) {
  left: 45px;
  animation: c-loading3 0.6s infinite;
}

@keyframes c-loading1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}

@keyframes c-loading2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(19px, 0);
  }
}

@keyframes c-loading3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
</style>
